import { Stack, Typography } from "@mui/material"
import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import Gt368Form from "../../components/commissioning/gt368/gt368Form"
import Less368Form from "../../components/commissioning/less386/less368Form"
import ErrorDisplay from "../../components/fallback/errorDisplay"
import CreateApplicationSkeleton from "../../components/loading/skeletons/createApplicationSkeleton"
import useLaunchCxForm from "../../services/middleware/hooks/commissioning/installer/useLaunchCxForm"
import { isCxGreater368 } from "../../services/middleware/types/commissioning/installer/launchCxFormTypes"
import { GRID_SPACING } from "../../themes/defaultThemeParams"

interface ISubmitCommissioningParams {
    applicationId: string
}

const SubmitCommissioning = (): ReactElement => {
    const { applicationId } = useParams<
        keyof ISubmitCommissioningParams
    >() as ISubmitCommissioningParams
    const { data, error, isLoading } = useLaunchCxForm(applicationId)

    if (isLoading) return <CreateApplicationSkeleton />
    if (error) return <ErrorDisplay error={error} />
    if (!data) return <Typography>No data</Typography>

    if (isCxGreater368(data)) {
        return (
            <Stack spacing={GRID_SPACING}>
                <Gt368Form
                    siteDataFormProperties={
                        data.formSchema.properties.siteData.properties
                    }
                    deviceDataFormProperties={
                        data.formSchema.properties.devices.items.properties
                    }
                    devices={data.devicesRequiringCx}
                    formVersion={data.cxFormVersion}
                    applicationId={applicationId}
                    initialValues={data.formData || {}}
                    customerAddress={data.customerAddress}
                    dno={data.dno}
                />
            </Stack>
        )
    }

    return (
        <Stack spacing={GRID_SPACING}>
            <Less368Form
                siteDataFormProperties={
                    data.formSchema.properties.siteData.properties
                }
                formVersion={data.cxFormVersion}
                applicationId={applicationId}
                initialValues={data.formData || {}}
                customerAddress={data.customerAddress}
                dno={data.dno}
            />
        </Stack>
    )
}

export default SubmitCommissioning
